export default "__VITE_ASSET__ChetMWly__"